/*
  isEventSupported.js
*/

/** 
 * Checks if an event is supported by the browser.
 *
 * Based on:
 * https://gist.github.com/Alex1990/d0f2b7447021d9e45b2d
 */
export default function isEventSupported(name) {
  
  name = 'on' + name;

  let testEl = document.createElement('div');
  let isSupported = (name in testEl);

  if (!isSupported) {
    testEl.setAttribute(name, 'return;');
    isSupported = typeof testEl[name] === 'function';
  }

  testEl = null;

  return isSupported;

}
